import { render } from "./AlbumsList.vue?vue&type=template&id=0632dc61&scoped=true&ts=true"
import script from "./AlbumsList.vue?vue&type=script&lang=ts"
export * from "./AlbumsList.vue?vue&type=script&lang=ts"

import "./AlbumsList.vue?vue&type=style&index=0&id=0632dc61&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0632dc61"]])

export default __exports__